"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regularDelivery = void 0;
var qs_1 = require("qs");
exports.regularDelivery = function (axios) {
    return {
        getProductsRegularDeliveryDetail: function (_a) {
            var productNo = _a.pathParams.productNo;
            return axios.get("/products/regular-delivery/" + productNo);
        },
        getProductsRegularDelivery: function (request) {
            var query = qs_1.stringify(request.params, { allowDots: true, arrayFormat: 'comma' });
            return axios.get("/products/regular-delivery?" + query);
        },
        putProductsRegularDelivery: function (request) {
            return axios.put('/products/regular-delivery', request.data);
        },
        putProductsRegularDeliveryV2: function (request) {
            return axios.put('/products/regular-delivery', request.data);
        },
        putProductsRegularDeliveryPause: function (request) {
            return axios.put('/products/regular-delivery/pause', request.data);
        },
        postProductsRegularDelivery: function (request) {
            return axios.post('/products/regular-delivery', request.data);
        },
        postProductsRegularDeliveryV2: function (request) {
            return axios.post('/products/regular-delivery', request.data);
        },
        deleteProductsRegularDelivery: function (request) {
            var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
            return axios.delete("/products/regular-delivery?" + query);
        }
    };
};
